import { Component, OnInit } from '@angular/core';
import { PageComponent } from '@icc/helpers';
import { _ } from '@icc/configurator/shared';
import { DynamicElementsService } from '@icc/common';

@Component({
  selector: 'dimensions-info',
  templateUrl: './dimensions-info.component.html',
  styleUrls: ['./dimensions-info.component.scss']
})
export class DimensionsInfoComponent extends PageComponent implements OnInit {
  public title = _('CONFIGURATOR|Jak mierzyć rolete?');
  dimensionsInfo: string;

  constructor(
    private dynamicElementsService: DynamicElementsService
  ) { 
    super();
  }

  ngOnInit(){
    this.dimensionsInfo = this.dynamicElementsService.getElementContentBySlug('dimension-shutter-info');
  }
}
